import script from "./CallsReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallsReview.vue?vue&type=script&setup=true&lang=ts"

import "./CallsReview.vue?vue&type=style&index=0&id=06adbb4f&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06adbb4f"]])

export default __exports__